import PackageCard from "@/components/cards/PackageCard";
import ScaledCard from "@/components/studio/ScaledCard";
import PackCompare from "./PackCompare";

export default function Offers({ data, width, track }) {
  return (
    <section className="pub-section" data-testid="section-oferte">
      <header className="pub-sec-head">
        <span className="pub-eyebrow">Discount financiar aplicat</span>
        <h2>Oferte active</h2>
        <p>{data.packages.length} pachete pentru salon. Compară-le și comandă direct pe WhatsApp.</p>
      </header>
      <PackCompare data={data} track={track} />
      <div className="pub-cards">
        {data.packages.map((pk, i) => (
          <ScaledCard key={pk.id} width={width}>
            <PackageCard pack={pk} index={i + 1} cat={data} contact={data.contact} />
          </ScaledCard>
        ))}
      </div>
    </section>
  );
}
